import { AfterViewInit, Component } from '@angular/core';

import { CustomFieldsService } from '@modules/customFields/services';
import { DateRangePickerComponent } from '@modules/shared/components';
import { CustomFormComponent } from '@services/formBuilder/abstract-custom-form-field';
import { CustomField, CustomFieldType } from '@modules/customFields/custom-fields.interfaces';
import { ObservationSubtypes, ObservationTypes } from '@services/observations/observation.interfaces';
import { AccountsService, FormBuilderService, FormConfig, FormField, ObservationService, TeamsService, UserdataService, UserService } from '@services';

import { v4 as uuidv4 } from 'uuid';
import { assign, find, includes } from 'lodash';

@Component({
  selector: 'app-filter-custom-field',
  templateUrl: './filter-custom-field.component.html',
  styleUrls: ['./filter-custom-field.component.scss'],
})
export class FilterCustomFieldComonent extends CustomFormComponent implements AfterViewInit {
  public uuid: string;
  public field: CustomField;
  public isCalculated: boolean;
  private formPrefix = `newObservation_${uuidv4()}`;
  public formId = `${this.formPrefix}Form`;

  private formConfig: FormConfig = {
    prefix: this.formPrefix,
    enableChangeDetectionMode: false,
    hideChangeDetectionPanel: true,
    fields: []
  };

  constructor(
    private observationService: ObservationService,
    private customFieldsService: CustomFieldsService,
    private formBuilderService: FormBuilderService,
    private userService: UserService,
    private userdataService: UserdataService,
    private accounts: AccountsService,
    private teamService: TeamsService
  ) {
    super();
  }

  ngAfterViewInit() {
    this.defineField();
  }

  public emitChange(event) {
    this.formValue = event;
  }

  private defineField() {
    const calculatedTypes = [
      CustomFieldType.Number,
      CustomFieldType.NumberBarcode
    ];
    this.field = this.getField(this.uuid);

    if (includes(calculatedTypes, this.field.type)) {
      this.isCalculated = true;
    } else {
      this.initForm();
    }
  }

  private getField(uuid: string): CustomField {
    const fields = this.observationService.getSettingsByType(ObservationTypes.Quality, ObservationSubtypes.QualityRMA)?.customFields?.data;
    return find(fields, { uuid: this.uuid });
  }

  private initForm() {
    let formField: FormField;
    const dropdownTypes = [
      CustomFieldType.Multiselect,
      CustomFieldType.Select,
      CustomFieldType.SingleSelect,
      CustomFieldType.Team,
      CustomFieldType.Teams,
      CustomFieldType.User,
      CustomFieldType.Users
    ];
    const textTypes = [
      CustomFieldType.Input,
      CustomFieldType.Textarea
    ];
    const dateTypes = [
      CustomFieldType.Date,
      CustomFieldType.Datetime
    ];

    if (includes(textTypes, this.field.type)) {
      formField = {
        type: 'text'
      };
    } else if (includes(dropdownTypes, this.field.type)) {
      if (includes([CustomFieldType.User, CustomFieldType.Users], this.field.type)) {
        formField = {
          type: 'selectmenu',
          multiple: true,
          valueProperty: 'userID',
          options: this.accounts.getUserlist(this.userdataService.locations),
          test: (ref) => {
            if (ref.disabledAt !== 0 || !ref.active) {
              return false;
            } else {
              return true;
            }
          },
          func: (ref) => this.userService.getFullname(ref.userID)
        };
      } else if (includes([CustomFieldType.Teams, CustomFieldType.Team], this.field.type)) {
        formField = {
          type: 'selectmenu',
          multiple: true,
          valueProperty: 'groupID',
          options: this.teamService.getTeamList(this.userdataService.locations),
          test: (ref) => {
            if (ref.hasOwnProperty('disabledAt') && ref.disabledAt) {
              return false;
            } else {
              return true;
            }
          },
          func: (ref) => this.teamService.teamName(ref)
        };
      } else {
        const field = this.customFieldsService.buildFields([this.field])?.[0];

        if (field) {
           formField = {
            type: 'selectmenu',
            multiple: true,
            valueProperty: 'id',
            options: field.props.options,
            func: (ref) =>  ref.description,
          };
        }
      }
    } else if (includes(dateTypes, this.field.type)) {
      formField = {
        type: 'customElement',
        containerClass: 'inline',
        noLabelInCustomElement: true,
        component: DateRangePickerComponent,
        inputs: {
          noLabel: true,
          isTimePicker: this.field.type === CustomFieldType.Datetime,
          useUTC: false,
          emptyDefaultValue: true,
          singleDatePicker: false,
          dateRange: this.formValue || {}
        },
      };
    }

    if (formField) {
      assign(formField, {
        onChange: (data) => this.emitChange(data),
        name: 'customField'
      });

      this.formConfig.fields = [formField];
      this.formBuilderService.showForm(`#${this.formId}`,this.formConfig, { customField: this.formValue });
    }
  }
}
